module.exports = __webpack_public_path__ + "static/img/D4104_.abbe269b.png";